import type { StaticPageResource } from "@solvari/statamic";
import type { LocaleMorpheus } from "@solvari/translations";

import type { StatamicPreview } from "~/shared/composables/useStatamicPreview.ts";

import { useCmsEntryQuery } from "~/shared/composables/useCmsApi.ts";

function useStaticPage(
  params: { locale: LocaleMorpheus; uri: string },
  preview?: StatamicPreview,
) {
  return useCmsEntryQuery<StaticPageResource>(
    {
      blueprint: "staticPage",
      collection: "pages",
      locale: params.locale,
      uri: params.uri,
    },
    preview,
  );
}

export { useStaticPage };
